<template>
    <div class="footer">
        <div>
            <span class="PCview" @click="modechange()">PC모드</span>
        </div>
    </div>
</template>
<script>
export default {
    name:'mobile_footer',
    props:[
        
    ],
    data(){
        return{

        }
    },
    mixins:[

    ],
    components:{

    },
    mounted() {
    },
    methods:{
        modechange(){
            this.$router.push({name:'home'});
            this.$store.state.sets.mode = 'PC';
        }
    }
}
</script>
<style lang="scss" scoped>
.footer{    
    background: #fff;
    display: flex;
    justify-content: center;
    height:100px;
    margin-bottom:150px;
    .PCview{
        margin-top:20px;
        display: inline-block;
        padding:5px 60px;
        background: rgb(32, 150, 101);
        border-radius: 999px;
        font-size:16px;
        color:#fff;
        cursor: pointer;

    }
}
</style>